import { TimetableState } from '@/components/Timetable/models/TimetableState';

export class TimetableStates {

    static Undefined: TimetableState = new TimetableState(0, "Undefined");
    static New: TimetableState = new TimetableState(10, "New");
    static Ordered: TimetableState = new TimetableState(100, "Ordered");
    static OrderedProcessing: TimetableState = new TimetableState(110, "OrderedProcessing");
    static Accepted: TimetableState = new TimetableState(200, "Accepted");
    static AcceptedModified: TimetableState = new TimetableState(210, "AcceptedModified");
    static AcceptedOld: TimetableState = new TimetableState(220, "AcceptedOld");
    static Rejected: TimetableState = new TimetableState(300, "Rejected");
    static RejectedModified: TimetableState = new TimetableState(310, "RejectedModified");
    static RejectedOld: TimetableState = new TimetableState(320, "RejectedOld");

    static States = [
        TimetableStates.Undefined,
        TimetableStates.New,
        TimetableStates.Ordered,
        TimetableStates.OrderedProcessing,
        TimetableStates.Accepted,
        TimetableStates.AcceptedModified,
        TimetableStates.AcceptedOld,
        TimetableStates.Rejected,
        TimetableStates.RejectedModified,
        TimetableStates.RejectedOld
    ]

    static SelectableStates = [
            TimetableStates.New,
            TimetableStates.Ordered,
            TimetableStates.OrderedProcessing,
            TimetableStates.Accepted,
            TimetableStates.Rejected,
    ]
    
    klass: object = TimetableStates;
}

export default TimetableState;
